import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Router} from "@angular/router";
import {catchError, Observable, throwError} from "rxjs";
import {NotificationService} from "../shared/services/notification.service";

@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

    CONNECTION_ERROR : string = "Erreur lors de la connexion au serveur";

    /**
     * Authentication / authorization statuses: they are handled by the Keycloak flow
     * and the route guards. They can occur transiently while the token is being set up
     * (right after the authentication redirect returns), so we do not want to turn them
     * into an error pop-up for the user. cf. CQT-244
     */
    readonly SILENT_STATUSES: ReadonlyArray<number> = [401, 403];

    constructor(private router: Router, private notification: NotificationService) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((err) => {
                if (err.status === 0) {
                    this.notification.showError('Erreur', this.CONNECTION_ERROR);
                } else if (!this.SILENT_STATUSES.includes(err.status) && err.error?.message) {
                    this.notification.showError(`Erreur ${err.status}`, err.error.message);
                }
                return throwError(() => new Error(this.CONNECTION_ERROR));
            })
        );
    }
}
